import { defaultPercentField, defaultField } from "helpers/row-logic-helper";
import { get } from "lodash";

export const individualOwnersMapNestedRows = loan => {
  const items = defaultField(loan, "individualOwners");

  return items.reduce((accum, item) => {
    const percentAllocated = defaultPercentField(item, "ownershipPercentage", 1);
    const isExternalEquitySource = get(item, "isExternalEquitySource");

    accum.push({
      name: defaultField(item, "contact.fullName"),
      percentAllocated: percentAllocated ? `${percentAllocated}% Allocated` : undefined,
      isExternalEquitySource: isExternalEquitySource ? "External Equity" : "Internal Equity"
    });

    return accum;
  }, []);
};
